import React from 'react'
import PhoneInput from "react-phone-input-2";
import "./PhoneInput.css";

export default function Input(props) {
  return <PhoneInput {...props} />;
}
